import * as i18n from "i18next";
import { initReactI18next } from "react-i18next";
import * as i18nextXHR from "i18next-xhr-backend";

export const init = (frontEndUrl: string, bundleNames: string[]) => {
    if (i18n.default.isInitialized) return;

    i18n.default
        .use(i18nextXHR.default)
        .use(initReactI18next)
        .init({
            fallbackLng: "en",

            ns: bundleNames,
            defaultNS: bundleNames[0],

            debug: false,

            keySeparator: false,

            interpolation: {
                escapeValue: false, // not needed for react
                formatSeparator: ",",
            },

            react: {
                // note: don't set this to 'true' => needed for positioning of popups
                wait: false,
            },

            backend: {
                loadPath:
                    frontEndUrl +
                    "locales/{{lng}}/{{ns}}.json?" +
                    BUNDLEBUILDTIME,
                crossDomain: true,
            },
        });
};
